import Header from "../pages/Header";
import Footer from "./Footer";
import styles from "../pages/TermsofUse.module.css";
import logo from "../media/cart7_logo_black.png";

function RefundReturn () {
  return(
    <>
    <Header />
    <div className={styles.fullWrapper}>
      <div className={styles.container}>
        <div  className={styles.logo}><img src={logo} alt="logo" /></div>
        <h2>Refund & Return Policy</h2>

<h3>Last Updated: [14 March 2026]</h3>

We want our customers to have a satisfactory shopping experience. Please read our refund and return policy carefully.

<h3>1. Returns</h3>

Products may be eligible for return if:

The item received is damaged or defective

The wrong product was delivered

You must contact us within [2 days] of receiving the product to request a return.

<h3>2. Return Conditions</h3>

To qualify for a return:

The item must be unused

The product should be in its original packaging

Proof of purchase or order confirmation may be required

<h3>3. Refunds</h3>

Once the returned item is inspected and approved, we will process the refund. Refunds may be issued through:

The original payment method, or

Another mutually agreed method.

Processing time may vary depending on the payment provider.

<h3>4. Non-Returnable Items</h3>

Certain items may not be eligible for return due to hygiene, customization, or other reasons.

<h3>5. Contact for Returns</h3>

To initiate a return or refund request, please contact us through WhatsApp support available on the website.
      </div>
    </div>
    <Footer />
    </>
    );
}
export default RefundReturn;